const controller = function(component){
    var controller = this;
    var widgets = {};
    var action = 'widget';

    this.downloadWidget = function(){
        var call = 'getWidgets';
        var data = {
            program_reference: component.program_reference,
            survey_reference: component.survey_reference
        }
        component.$sendRequest({
            action: action,
            call: call,
            data: data
        }).then(function(response){
            var widget_list = response.data[action][call].widgets;
            for(let w=0; w<widget_list.length; w++){
                var widget_name = widget_list[w];
                widgets[widget_name] = {
                    trigger: false
                };
            }
            controller.widgets = widgets;
            component.loaded_widgets = widgets;
        })
    }

    this.widgets = widgets;
}

export default controller;